import InputSkeletonPlaceholder from './input-skeleton-placeholder';

export default InputSkeletonPlaceholder;
